export * from './adders'
export * from './agents'
export * from './agreement-doc'
export * from './amortization-schedule'
export * from './checklist-item'
export * from './api-key'
export * from './api-client'
export * from './applicant'
export * from './airtable'
export * from './airtable-webhooks'
export * from './browser-fingerprint'
export * from './components'
export * from './consent'
export * from './credit-report'
export * from './types'
export * from './equifax-dit-report'
export * from './equifax-credit-report'
export * from './solar-tradeline'
export * from './loan-application'
export * from './document-types'
export * from './docusign'
export * from './applicant-race'
export * from './citizenship'
export * from './error'
export * from './equipment-types'
export * from './loan-calculations'
export * from './mcgb-loan-calculations'
export * from './loan-option'
export * from './org'
export * from './partiable'
export * from './pre-ntp-update'
export * from './presubmit-status'
export * from './required-additional-information'
export * from './product'
export * from './street-address'
export * from './status-data'
export * from './storage-key'
export * from './masking'
export * from './mime-types'
export * from './individual'
export * from './installer'
export * from './tenant'
export * from './date-utils'
export * from './decision-pro'
export * from './form-types'
export * from './constants'
export * from './change-orders'
export * as Validate from './validators'
export * from './test-data'
export * as LoanApplicationPhaseShared from './loan-application-phase'
export * as LoanFundingPhaseShared from './loan-funding-phase'
export * from './system-detail-validations'
export * from './project-cost-caps'
export * from './solar-monitoring'
export * from './test-project-fields'

// TODO: refactor over time to use Format 
export * from './formats'
export * as Format from './formats'


export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const NAME_REGEX = /^[a-zA-Z0-9.,#&()/\-\s\xC0-\uFFFF']+$/  // see test cases, allows diacritics and other
export const PHONE_REGEX = /^[0-9]{10}$/
export const DATE_REGEX = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/

export const pause = (secs: number) => new Promise(resolve => setTimeout(resolve, secs * 1000))


export const extractStreetFromAddress = (address: string): string => {
  // not exact, but good enough
  const [numAndStreet] = address.split(',')
  return numAndStreet.replace(/^\d+\s+/, '')
}
export interface MongooseModel {
  toObject: () => Record<string, unknown>
}

// lock existing properties, but allow modification of new ones
export const freezeprops = (obj: Record<string, unknown>): Record<string, unknown> => {
  Object.keys(obj).forEach(k => {
    Object.defineProperty(obj, k, {
      value: obj[k],
      writable: false,
      enumerable: true
    })
  })

  return obj
}